//
import { iframeResize } from "iframe-resizer";
//
const resize = {
  getSSRProps() {
    // noop needed to be SSR compatible
    return {};
  },
  beforeMount: function (el, { value = {} }) {
    el.addEventListener("load", () => iframeResize(value, el));
  },
  unmounted: function (el) {
    el.iFrameResizer?.removeListeners();
  },
};
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("iframe-resize", resize);
});
